module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VueCarousel-navigation"
  }, [_c('button', {
    staticClass: "VueCarousel-navigation-button VueCarousel-navigation-prev",
    class: {
      'VueCarousel-navigation--disabled': !_vm.canAdvanceBackward
    },
    style: (("padding: " + _vm.clickTargetSize + "px; margin-right: -" + _vm.clickTargetSize + "px;")),
    attrs: {
      "type": "button",
      "aria-label": "Previous page",
      "tabindex": _vm.canAdvanceBackward ? 0 : -1
    },
    domProps: {
      "innerHTML": _vm._s(_vm.prevLabel)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerPageAdvance('backward')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "VueCarousel-navigation-button VueCarousel-navigation-next",
    class: {
      'VueCarousel-navigation--disabled': !_vm.canAdvanceForward
    },
    style: (("padding: " + _vm.clickTargetSize + "px; margin-left: -" + _vm.clickTargetSize + "px;")),
    attrs: {
      "type": "button",
      "aria-label": "Next page",
      "tabindex": _vm.canAdvanceForward ? 0 : -1
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nextLabel)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerPageAdvance('forward')
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38c4f279!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/vue-carousel/Navigation.vue
// module id = 2016
// module chunks = 2